import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  Container: {
    width: '50vw',
    padding: '30px',
  },
}))
